import { z } from '../zod';
import { ObjectIdStringValidationSchema } from '../shared/ObjectId';

const fromAllPagesDescription =
  'Also remove the order bump from every page that offers it. Without it, deleting a product that is still offered on a page is refused.';

export const DeleteProductQueryValidationSchema = z.object({
  fromAllPages: z
    .enum(['true', 'false'])
    .optional()
    .transform(value => value === 'true')
    .meta({ description: fromAllPagesDescription }),
});

export const DeleteProductInputValidationSchema = z.object({
  productId: ObjectIdStringValidationSchema.meta({
    description: 'The ID of the order bump product to delete.',
  }),
  fromAllPages: z.boolean().optional().meta({ description: fromAllPagesDescription }),
});

export type DeleteProductInput = z.infer<typeof DeleteProductInputValidationSchema>;

export const DeleteProductResponseValidationSchema = z
  .object({
    data: z.object({
      success: z.boolean(),
      message: z.string(),
    }),
  })
  .meta({ description: 'Confirms the product was deleted.' });
